import { render, staticRenderFns } from "./ListShell.vue?vue&type=template&id=1af2ea20&scoped=true"
import script from "./ListShell.vue?vue&type=script&lang=js"
export * from "./ListShell.vue?vue&type=script&lang=js"
import style0 from "./ListShell.vue?vue&type=style&index=0&id=1af2ea20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af2ea20",
  null
  
)

export default component.exports